import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';

type SetPasswordProps = {
  userData: {
    password: string
    confirm_password: string
    token: string | null
  }
  errors: {
    password: string
    confirm_password: string
  }
  setErrors:(value: any) => void;
  setUserData: (value: any) => void;
  steps: string[]
  activeStep: number
  setActiveStep:(value: number) => void;
};

export default function SetPassword({
  userData, errors, setErrors, setUserData, steps, activeStep, setActiveStep,
} : SetPasswordProps) {
  const [open, setOpen] = React.useState(false);
  const [userError, setuserError] = React.useState('');
  const handleNext = () => {
    if (userData.password.trim() === '') {
      setErrors({ ...errors, password: 'This field required' });
    } else if (userData.password.length < 8) {
      setErrors({ ...errors, password: 'Password must be 8 char or more' });
    } else if (userData.confirm_password.trim() === '') {
      setErrors({ ...errors, confirm_password: 'This field required' });
    } else if (userData.password !== userData.confirm_password) {
      setErrors({ ...errors, confirm_password: 'confirm password not match password' });
    } else {
      fetch(`${process.env.REACT_APP_SERVER_HOSTNAME}/complete_user_profile_password`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        method: 'POST',
        body: JSON.stringify(userData),
      })
        .then(async (response) => {
          const data = await response.json();
          if (response.status === 200) {
            setActiveStep(activeStep + 1);
          } else {
            setuserError(data.error);
            setOpen(true);
          }
        })
        .catch((error) => {
          setuserError(error);
          setOpen(true);
        });
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleChange = (name: string, value: string) => {
    setErrors({ ...errors, password: '', confirm_password: '' });
    setUserData({ ...userData, [name]: value });
  };

  return (
    <>
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Collapse in={open}>
          <Alert severity='error'>
            {userError}
          </Alert>
        </Collapse>
      </Stack>
      <Typography variant='h6' gutterBottom>
        Set Password
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            error={errors.password !== ''}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userData.password}
            helperText={errors.password !== '' ? errors.password : ''}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            error={errors.confirm_password !== ''}
            margin='normal'
            required
            fullWidth
            name='confirm_password'
            label='Confirm Password'
            type='password'
            id='password'
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userData.confirm_password}
            helperText={errors.confirm_password !== '' ? errors.confirm_password : ''}
          />
        </Grid>
      </Grid>
      {activeStep === steps.length ? (
        <Typography variant='h5' gutterBottom>
              Thank you for your submission.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {activeStep !== 0 && (
            <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                  Back
            </Button>
          )}

          <Button
            name='next'
            variant='contained'
            onClick={handleNext}
            sx={{ mt: 3, ml: 1 }}
          >
            {activeStep === steps.length - 1 ? 'Update' : 'Next'}
          </Button>
        </Box>
      )}
    </>

  );
}
